import {createContext, useContext} from "react";

export const NotificationsContext = createContext<{
  target?: HTMLElement|null;
}>({});
export const useNotificationContext = () => {
  return useContext(NotificationsContext);
};
